var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithubd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "github-142-svgrepo-com 1",
    clipPath: "url(#clip0_51_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "github-[#142]",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8848 0C60.2068 0 77.4907 18.3597 77.4907 41.0117C77.4907 59.1277 66.4417 74.4958 51.1113 79.9238C49.1539 80.3278 48.459 79.0471 48.459 77.9551C48.459 76.6031 48.5053 72.1872 48.5053 66.6992C48.5053 62.8752 47.27 60.3794 45.884 59.1074C54.4816 58.0914 63.5153 54.6231 63.5153 38.8711C63.5153 34.3911 62.0174 30.7353 59.5389 27.8633C59.9404 26.8273 61.2646 22.6558 59.1606 17.0078C59.1606 17.0078 55.9254 15.9089 48.5555 21.2129C45.4709 20.3049 42.1663 19.848 38.8848 19.832C35.6033 19.848 32.3025 20.3049 29.2217 21.2129C21.8441 15.9089 18.6012 17.0078 18.6012 17.0078C16.5049 22.6558 17.8291 26.8273 18.2268 27.8633C15.7598 30.7353 14.2504 34.3911 14.2504 38.8711C14.2504 54.5831 23.2648 58.1046 31.8392 59.1406C30.7351 60.1646 29.7352 61.971 29.3877 64.623C27.1872 65.671 21.597 67.4848 18.1534 61.2168C18.1534 61.2168 16.1111 57.2763 12.2351 56.9883C12.2351 56.9883 8.47104 56.9365 11.9726 59.4805C11.9726 59.4805 14.5013 60.7405 16.2578 65.4805C16.2578 65.4805 18.524 72.8003 29.2642 70.3203C29.2835 73.7483 29.3182 76.9791 29.3182 77.9551C29.3182 79.0391 28.6079 80.3077 26.6814 79.9277C11.3394 74.5077 0.27887 59.1317 0.27887 41.0117C0.27887 18.3597 17.5666 0 38.8848 0Z",
    fill: "#262523"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.2118,
    height: 80,
    fill: "white",
    transform: "translate(0.27887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubd);
export default __webpack_public_path__ + "static/media/githubd.e4e8f7230ab82c3e0e0083176f102bc6.svg";
export { ForwardRef as ReactComponent };